// Functions
function setUnitSystemPreference(system) {

    // Default system value
    let defaultSystem = 'metric';

    // Get location from storage
    if (!system) {
        system = localStorage.getItem('gann_user_preference_unitsystem');
    }

    // Validate system value
    let isValidSystem = document.getElementById('unitsystem-preference').querySelector('[value="' + system + '"]');
    if (!isValidSystem)
        system = defaultSystem;

    // Set select elements
    document.querySelectorAll('[data-select-preference="unitsystem"]').forEach(function (element) {
        element.value = system;
    });

    // Unhide elements based on preference
    document.querySelectorAll('[data-unitsystem]').forEach(item => {
        if (system === 'imperial') {
            item.querySelector('.imperial').classList.remove('d-none');
            item.querySelector('.metric').classList.add('d-none');
        } else {
            item.querySelector('.imperial').classList.add('d-none');
            item.querySelector('.metric').classList.remove('d-none');
        }
    });

    // Store
    localStorage.setItem('gann_user_preference_unitsystem', system);
}

// Initializer
setUnitSystemPreference();

// Listeners
document.querySelectorAll('[data-select-preference="unitsystem"]').forEach(function (element) {
    element.addEventListener('change', function() {
        setUnitSystemPreference(element.value);
    });
});
